import React from 'react';
import { Typography } from '@material-ui/core';
import { HealtheraButton } from '../../../healtheraComponents';
import { Header, Container } from '../../Shared/Table';
import QuestionnairesListContainer from './components/QuestionnairesListContainer';
import { useHistory } from 'react-router';

const QuestionnairesList = () => {
  const history = useHistory();

  function addNewQuestionnaire() {
    history.push('/questionnaires/create');
  }

  return (
    <Container>
      <Header>
        <Typography variant="h4">Questionnaires</Typography>
        <HealtheraButton onClick={addNewQuestionnaire}>Add new</HealtheraButton>
      </Header>
      <QuestionnairesListContainer />
    </Container>
  );
};
export default QuestionnairesList;
